import React, { useContext } from "react";
import { EMOJI_TYPE } from "./../../ricos-content";
import {
  EditorContext,
  ModalServiceContext,
  PluginsEventsContext,
  RicosContext
} from "./../../ricos-context";
import { Panel, PanelHeader } from "./../../ui-components";
import EmojiSelectorLazy from "../emoji-selector-lazy";
import { emojiModals } from "../types";
const EmojiInsertModal = () => {
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const modalService = useContext(ModalServiceContext) || {};
  const closeModal = () => {
    modalService?.closeModal(emojiModals.insert);
  };
  const onEmojiAdd = (emoji) => {
    getPublicCommands()?.insertText(emoji);
    pluginsEvents.publishPluginAddSuccess({ pluginId: EMOJI_TYPE, params: { emoji } });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(Panel, { onCloseButtonClick: closeModal, width: 352 }, /* @__PURE__ */ React.createElement(PanelHeader, { title: t("EmojiPlugin_InsertModal_Title") }), /* @__PURE__ */ React.createElement(EmojiSelectorLazy, { onEmojiAdd }));
};
var InsertModal_default = EmojiInsertModal;
export {
  InsertModal_default as default
};
//# sourceMappingURL=InsertModal.js.map
